import React from 'react';
import SimpleSchedule from './components/SimpleSchedule';

function App() {
  return (
    <div className="container mx-auto">
      <SimpleSchedule />
    </div>
  );
}

export default App;
